import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';

import { FormsModule } from '@angular/forms';

@Component({
  selector: 'jmkw-checkbox',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxComponent {
  @Input() id?: string;
  @Input() fontSizeRem = 1.4;
  @Input() selected?: boolean;
  @Input() indeterminate?: boolean;
  @Input() label?: string;
  @Input() automationKey?: string;

  @Output() selectChanged = new EventEmitter<boolean>();

  @ViewChild('checkbox', { static: true })
  checkboxRef!: ElementRef<HTMLInputElement>;

  checkboxChangeHandler(eventTarget: EventTarget): void {
    const selected = (eventTarget as HTMLInputElement).checked;
    this.selectChanged.emit(selected);
  }
}
